"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmptyValue = exports.isElement = exports.isTextElement = void 0;
const isTextElement = (sdkInstance) => exports.isElement(sdkInstance) &&
    (sdkInstance.type === '$w.Text' || sdkInstance.type === '$w.CollapsibleText');
exports.isTextElement = isTextElement;
const isElement = (sdkInstance) => Boolean(sdkInstance.id && sdkInstance.uniqueId && sdkInstance.type);
exports.isElement = isElement;
const isEmptyValue = (value) => value === undefined || value === null;
exports.isEmptyValue = isEmptyValue;
//# sourceMappingURL=assertions.js.map